import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Header,
  Menu,
} from 'semantic-ui-react';
import _ from 'lodash';
import { numericRange } from '@mhub/web-validations';
import AppForm from '../../components/AppForm';
import UploadForm from './UploadForm';
import { fetchM } from '../../actions/fetchM';
import { flashErrorMessage } from '../../actions/flash';

export default class NewIncomeForm extends Component {
  static propTypes = {
    customerID: PropTypes.string,
    data: PropTypes.shape({
      epfStatementDocumentID: PropTypes.string,
      epfStatementDocument: PropTypes.shape({
        key: PropTypes.string,
        tags: PropTypes.arrayOf(
          PropTypes.string,
        ),
      }),
      payslipDocumentID: PropTypes.string,
      payslipDocument: PropTypes.shape({
        key: PropTypes.string,
        tags: PropTypes.arrayOf(
          PropTypes.string,
        ),
      }),
      bankStatementDocumentID: PropTypes.string,
      bankStatementDocument: PropTypes.shape({
        key: PropTypes.string,
        tags: PropTypes.arrayOf(
          PropTypes.string,
        ),
      }),
      bFormDocumentID: PropTypes.string,
      bFormDocument: PropTypes.shape({
        key: PropTypes.string,
        tags: PropTypes.arrayOf(
          PropTypes.string,
        ),
      }),
    }),
    income: PropTypes.shape({
      id: PropTypes.string,
      isEmployed: PropTypes.bool,
      basicIncome: PropTypes.number,
      fixAllowance: PropTypes.number,
      grossIncome: PropTypes.number,
      deduction: PropTypes.number,
      netIncome: PropTypes.number,
      bYearlyIncome: PropTypes.number,
      otherYearlyIncome: PropTypes.number,
      currentLoanAmount: PropTypes.number,
    }),
    onChange: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,
    loading: PropTypes.bool,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static defaultValues = {
    bankStatementDocumentID: '',
    bankStatementDocument: null,
    basicIncome: 0,
    bFormDocumentID: '',
    bFormDocument: null,
    bYearlyIncome: 0,
    currentLoanAmount: 0,
    epfStatementDocumentID: '',
    epfStatementDocument: null,
    deduction: 0,
    fixAllowance: 0,
    grossIncome: 0,
    id: '',
    isEmployed: true,
    netIncome: 0,
    otherYearlyIncome: 0,
    payslipDocumentID: '',
    payslipDocument: null,
  }
  static getPropsToState = (props) => {
    const income = Object.assign({}, NewIncomeForm.defaultValues, props.income || {});
    return {
      income,
      oriIncome: Object.assign({}, income),
    };
  }
  constructor(props) {
    super(props);
    const state = NewIncomeForm.getPropsToState(props);
    this.state = {
      ...state,
      documentChanges: false,
      errMessages: [],
    };
    this.validation = {
      basicIncome: createRef(),
      fixAllowance: createRef(),
      deduction: createRef(),
      bYearlyIncome: createRef(),
      otherYearlyIncome: createRef(),
    };
  }
  componentDidMount() {
    this.fetchCustomerIncome();
  }
  componentWillReceiveProps(nextProps) {
    const state = NewIncomeForm.getPropsToState(nextProps);
    if (JSON.stringify(state.oriIncome) === JSON.stringify(this.state.oriIncome)) {
      state.income = this.state.income;
    }
    this.setState(state);
  }
  getDocumentToken(callback) {
    const { store } = this.context;
    store.dispatch(fetchM(`/customers/${this.props.customerID}/documents/`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }))
    .catch((err) => {
      store.dispatch(flashErrorMessage(err));
    })
    .then((res) => {
      const documentToken = res.headers.get('X-Csrf-Token');
      this.setState({
        documentToken,
      }, () => {
        if (callback) {
          callback();
        }
      });
    });
  }
  async fetchCustomerIncome() {
    const { store } = this.context;
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/customers/${this.props.customerID}/income/${this.props.data.income.id}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      // await this.setLoading(false);
      Bugsnag.notifyException(err);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    const json = await res.json();
    if (json) {
      const newIncome = Object.assign({}, json || {});
      this.setState({ income: newIncome });
    }
  }
  async uploadDocument(body, key = 'employed', validations, income) {
    const { store } = this.context;
    const { documentChanges } = this.state;
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/customers/${this.props.customerID}/income/documents/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          // Let browser decide Content-Type
          // 'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.documentToken,
        },
        body,
      }));
    } catch (err) {
      Bugsnag.notifyException(err);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    const json = await res.json();
    if (json) {
      const newIncome = Object.assign({}, income || {});
      newIncome.id = json.id;
      if (json.epfStatementDocumentID !== '') {
        newIncome.epfStatementDocumentID = json.epfStatementDocumentID;
        newIncome.epfStatementDocument = json.epfStatementDocument;
      }
      if (json.bankStatementDocumentID !== '') {
        newIncome.bankStatementDocumentID = json.bankStatementDocumentID;
        newIncome.bankStatementDocument = json.bankStatementDocument;
      }
      if (json.payslipDocumentID !== '') {
        newIncome.payslipDocumentID = json.payslipDocumentID;
        newIncome.payslipDocument = json.payslipDocument;
      }
      if (json.bFormDocumentID !== '') {
        newIncome.bFormDocumentID = json.bFormDocumentID;
        newIncome.bFormDocument = json.bFormDocument;
      }
      this.setState({ income: newIncome }, () => {
        this.props.onSubmit(validations, newIncome, documentChanges);
      });
    }
    if (key === 'employed') {
      await this.employedFormUpload.resetFiles();
    }
    if (key === 'selfEmployed') {
      await this.bFormUpload.resetFiles();
    }
  }
  handleChangeTab = (isEmployed = false) => {
    const { income } = this.state;
    income.isEmployed = isEmployed;
    this.setState({ income }, this.handleCheckNetIncome);
  }
  handleCheckChanges() {
    if (this.props.onChange) {
      const { income } = this.state;
      this.props.onChange(income);
    }
  }
  handleCreateFormData = (type) => {
    const { income } = this.state;
    let formData = null;
    if (type === 'employed') {
      if (income.epfStatementDocument || income.payslipDocument || income.bankStatementDocument) {
        formData = this.employedFormUpload.getFormData();

        if (income.epfStatementDocument) {
          formData.append('files_0', income.epfStatementDocument.file);
          formData.append('tags_0', income.epfStatementDocument.tags);
          formData.append('names_0', income.epfStatementDocument.name);
          formData.append('degrees_0', income.epfStatementDocument.degree);
        }
        if (income.payslipDocument) {
          formData.append('files_1', income.payslipDocument.file);
          formData.append('tags_1', income.payslipDocument.tags);
          formData.append('names_1', income.payslipDocument.name);
          formData.append('degrees_1', income.payslipDocument.degree);
        }
        if (income.bankStatementDocument) {
          formData.append('files_2', income.bankStatementDocument.file);
          formData.append('tags_2', income.bankStatementDocument.tags);
          formData.append('names_2', income.bankStatementDocument.name);
          formData.append('degrees_2', income.bankStatementDocument.degree);
        }
      }
    } else if (type === 'selfEmployed') {
      if (income.bFormDocument) {
        formData = this.bFormUpload.getFormData();
        formData.append('files_0', income.bFormDocument.file);
        formData.append('tags_0', income.bFormDocument.tags);
        formData.append('names_0', income.bFormDocument.name);
        formData.append('degrees_0', income.bFormDocument.degree);
      }
    }
    return formData;
  }
  handleGetForm = (form, formName = 'epfStatementDocument') => {
    const { income } = this.state;
    income[formName] = form;
    this.setState({ income, documentChanges: true }, () => {
      this.handleCheckChanges();
    });
  }
  handleCheckNetIncome() {
    const { income } = this.state;
    if (income.isEmployed) {
      const grossIncome = _.toNumber(_.toNumber(income.basicIncome) + _.toNumber(income.fixAllowance)).toFixed(2);
      income.grossIncome = _.toNumber(grossIncome);
      const netIncome = _.toNumber(_.toNumber(income.grossIncome) - _.toNumber(income.deduction)).toFixed(2);
      income.netIncome = _.toNumber(netIncome);
    }
    if (!income.isEmployed) {
      const totalYearlyIncome = _.toNumber(income.bYearlyIncome) + _.toNumber(income.otherYearlyIncome);
      const totalMonthlyIncome = _.toNumber(totalYearlyIncome) / 12;
      const roughIncome = _.toNumber(totalMonthlyIncome).toFixed(2);
      income.netIncome = _.toNumber(roughIncome);
    }
    this.setState({ income }, () => {
      this.handleCheckChanges();
    });
  }
  handleInputChange = (event, data) => {
    const { income } = this.state;
    income[data.name] = _.toNumber(data.value);
    this.handleCheckNetIncome();
  }
  handleSubmit = () => {
    const { income, documentChanges } = this.state;
    if (income.isEmployed) {
      income.bYearlyIncome = 0;
      income.otherYearlyIncome = 0;
      income.bFormDocumentID = '';
      income.bFormDocument = null;
    }
    if (!income.isEmployed) {
      income.basicIncome = 0;
      income.fixAllowance = 0;
      income.grossIncome = 0;
      income.deduction = 0;
      income.epfStatementDocumentID = '';
      income.epfStatementDocument = null;
      income.payslipDocumentID = '';
      income.payslipDocument = null;
      income.bankStatementDocumentID = '';
      income.bankStatementDocument = null;
    }
    AppForm.validate(this.validation, income)
      .then((validations) => {
        this.setState({
          errMessages: validations.filter(v => !v.isValid),
        });
        if (documentChanges) {
          this.submitAllIncome(validations, income);
        } else {
          this.props.onSubmit(validations, income, documentChanges);
        }
      });
  }
  submit(url, opts) {
    return this.form.submit(url, opts);
  }
  submitAllIncome = async (validations, income) => {
    const { store } = this.context;
    try {
      await this.getDocumentToken(() => {
        if (income.isEmployed) {
          const employedForm = this.handleCreateFormData('employed');
          this.uploadDocument(employedForm, 'employedForm', validations, income);
        } else {
          const selfEmployedForm = this.handleCreateFormData('selfEmployed');
          this.uploadDocument(selfEmployedForm, 'selfEmployed', validations, income);
        }
      });
    } catch (error) {
      store.dispatch(flashErrorMessage(error));
    }
  }
  tabs = [
    { name: 'isEmployed', text: 'Employed', isEmployed: true },
    { name: 'SelfEmployed', text: 'Self Employed', isEmployed: false },
  ];
  render() {
    const { data } = this.props;
    const { income } = this.state;
    return (
      <AppForm
        onSubmit={this.handleSubmit}
        error={this.state.errMessages.length > 0}
        ref={(ref) => { this.form = ref; }}
      >
        <Grid columns={1} textAlign="center" stackable doubling>
          <Grid.Row>
            <Grid.Column computer={8} tablet={10} mobile={16}>
              <div className="menuTab">
                <Menu fluid widths={2}>
                  {
                  this.tabs.map((tab, idx) => (
                    <Menu.Item
                      key={idx}
                      name={tab.name}
                      onClick={() => this.handleChangeTab(tab.isEmployed)}
                      active={income.isEmployed === tab.isEmployed}
                    >
                      {tab.text}
                    </Menu.Item>
                  ))
                }
                </Menu>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Grid centered>
          <Grid.Row>
            {
              income.isEmployed ? (
                <Grid.Column computer={7} tablet={9} mobile={16} textAlign="right">
                  <AppForm.Input
                    label={
                      <Header
                        as="h5"
                        style={{ marginBottom: '0.5em' }}
                        textAlign="left"
                        content="Basic Monthly Income"
                        subheader="Monthly Basic Salary, Monthly Recurring Commission before any deduction"
                      />
                    }
                    validateLabel="Basic Monthly Income"
                    type="number"
                    step="0.01"
                    name="basicIncome"
                    value={income.basicIncome}
                    onChange={this.handleInputChange}
                    validation={income.isEmployed ? [{
                      validate: numericRange,
                      option: {
                        min: 1,
                        message: 'Basic Monthly Income is required',
                      },
                    }] : null}
                    ref={this.validation.basicIncome}
                  />
                  <AppForm.Input
                    label={
                      <Header
                        as="h5"
                        style={{ marginBottom: '0.5em' }}
                        textAlign="left"
                        content="Fix Monthly Allowance"
                        subheader="Recurring fixed travel allowance, meal allowance, yearly contractual bonus/12months"
                      />
                    }
                    validateLabel="Fix Monthly Allowance"
                    type="number"
                    step="0.01"
                    name="fixAllowance"
                    value={income.fixAllowance}
                    onChange={this.handleInputChange}
                    ref={this.validation.fixAllowance}
                  />
                  <Header
                    as="h5"
                    style={{ marginBottom: '0.5em' }}
                    textAlign="left"
                    content="Gross Monthly Income"
                  />
                  <AppForm.Input
                    type="number"
                    step="0.01"
                    name="grossIncome"
                    value={income.grossIncome}
                    disabled
                    readOnly
                  />
                  <AppForm.Input
                    label={
                      <Header
                        as="h5"
                        style={{ marginBottom: '0.5em' }}
                        textAlign="left"
                        content="Monthly Income deduction"
                        subheader="EPF, SOSCO, PCB, CP38"
                      />
                    }
                    validateLabel="Monthly Income deduction"
                    type="number"
                    step="0.01"
                    name="deduction"
                    value={income.deduction}
                    onChange={this.handleInputChange}
                    ref={this.validation.deduction}
                  />
                  <Header
                    as="h5"
                    style={{ marginBottom: '0.5em' }}
                    textAlign="left"
                    content="Net Monthly Income"
                  />
                  <AppForm.Input
                    type="number"
                    step="0.01"
                    name="netIncome"
                    value={income.netIncome}
                    validation={income.isEmployed ? [{
                      validate: numericRange,
                      option: {
                        min: 1,
                        message: 'Net Monthly Income is required',
                      },
                    }] :
                    null
                    }
                    disabled
                    readOnly
                  />
                  <Header
                    as="h3"
                    content="Upload Documents"
                    textAlign="left"
                    style={{ marginTop: '2em', marginBottom: '0.5em' }}
                  />
                  <UploadForm
                    title="FinancialForm"
                    labelContent="Latest EPF Statement"
                    ref={(ref) => { this.employedFormUpload = ref; }}
                    loading={this.props.loading}
                    tags={['Financial EPF']}
                    picture={data.epfStatementDocumentID && data.epfStatementDocumentID.length > 0 ? data.epfStatementDocument : null}
                    onChange={form => this.handleGetForm(form, 'epfStatementDocument')}
                  />
                  <UploadForm
                    title="FinancialForm"
                    labelContent="Latest 3 months payslip"
                    ref={(ref) => { this.employedFormUpload = ref; }}
                    loading={this.props.loading}
                    tags={['Financial Payslip']}
                    picture={data.payslipDocumentID && data.payslipDocumentID.length > 0 ? data.payslipDocument : null}
                    onChange={form => this.handleGetForm(form, 'payslipDocument')}
                    style={{ height: '4rem !important' }}
                  />
                  <UploadForm
                    title="FinancialForm"
                    labelContent="Latest 3 months bank statement"
                    ref={(ref) => { this.employedFormUpload = ref; }}
                    loading={this.props.loading}
                    tags={['Financial BankStatement']}
                    picture={data.bankStatementDocumentID && data.bankStatementDocumentID.length > 0 ? data.bankStatementDocument : null}
                    onChange={form => this.handleGetForm(form, 'bankStatementDocument')}
                  />
                </Grid.Column>
              ) : null
            }
            {
              !income.isEmployed ? (
                <Grid.Column computer={7} tablet={9} mobile={16} textAlign="right">
                  <AppForm.Input
                    label={
                      <Header
                        as="h5"
                        style={{ marginBottom: '0.5em' }}
                        textAlign="left"
                        content="Latest B Form Yearly Income"
                      />
                    }
                    validateLabel="Latest B Form Yearly Income"
                    type="number"
                    step="0.01"
                    name="bYearlyIncome"
                    value={income.bYearlyIncome}
                    onChange={this.handleInputChange}
                    validation={!income.isEmployed ? [{
                      validate: numericRange,
                      option: {
                        min: 1,
                        message: 'B Form Yearly Income is required',
                      },
                    }] : null}
                    ref={this.validation.bYearlyIncome}
                  />
                  <AppForm.Input
                    label={
                      <Header
                        as="h5"
                        style={{ marginBottom: '0.5em' }}
                        textAlign="left"
                        content="Other Yearly Income"
                      />
                    }
                    validateLabel="Other Yearly Income"
                    type="number"
                    step="0.01"
                    name="otherYearlyIncome"
                    value={income.otherYearlyIncome}
                    onChange={this.handleInputChange}
                    ref={this.validation.otherYearlyIncome}
                  />
                  <Header
                    as="h5"
                    style={{ marginBottom: '0.5em' }}
                    textAlign="left"
                    content="Total"
                  />
                  <AppForm.Input
                    type="number"
                    step="0.01"
                    name="netIncome"
                    value={income.netIncome}
                    validation={!income.isEmployed ? [{
                      validate: numericRange,
                      option: {
                        min: 1,
                        message: 'Total is required',
                      },
                    }] :
                    null
                    }
                    disabled
                    readOnly
                  />
                  <Header
                    as="h3"
                    content="Upload Documents"
                    textAlign="left"
                    style={{ marginTop: '2em', marginBottom: '0.5em' }}
                  />
                  <UploadForm
                    title="FinancialForm"
                    labelContent="B Form"
                    ref={(ref) => { this.bFormUpload = ref; }}
                    loading={this.props.loading}
                    tags={['Financial BForm']}
                    picture={data.bFormDocumentID && data.bFormDocumentID.length > 0 ? data.bFormDocument : null}
                    onChange={form => this.handleGetForm(form, 'bFormDocument')}
                  />
                </Grid.Column>
              ) : null
            }
          </Grid.Row>
        </Grid>
      </AppForm>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/CreditCheck/NewIncomeForm.jsx